/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import qs from "qs";
import { api } from "../../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";
import { IApprovalFlow, IResponseListApprovalFlows } from "../../../interfaces/approvalFlows";
import { IResponseListApprovalFlowSteps } from "../../../interfaces/approvalFlowSteps";
import { IEntityCatalogItem } from "../../../interfaces/approvalFlowStepAutomation";
import { IFlowGraph, IFlowGraphInput, IFlowGraphIssue } from "../../../interfaces/approvalFlowGraph";

const BASE_FLOWS = "/approval_flows";
const BASE_STEPS = "/approval_flow_steps";
const BASE_CATALOG = "/approval_flows/entity_catalog";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listApprovalFlows({
  filter,
  includes,
  page,
  limit,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListApprovalFlows>(BASE_FLOWS, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export const createApprovalFlow = async (newApprovalFlow: Partial<IApprovalFlow>) => {
  const { data } = await api.post(BASE_FLOWS, { newApprovalFlow });
  return data;
};

export const updateApprovalFlow = async (id: number, approvalFlow: Partial<IApprovalFlow>) => {
  const { data } = await api.put(`${BASE_FLOWS}/${id}`, { approvalFlow });
  return data;
};

export const deleteApprovalFlow = async (id: number) => {
  const { data } = await api.delete(`${BASE_FLOWS}/${id}`);
  return data;
};

export async function listApprovalFlowSteps({
  filter,
  includes,
  page,
  limit,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListApprovalFlowSteps>(BASE_STEPS, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export const listEntityCatalog = async (entityType: string): Promise<IEntityCatalogItem[]> => {
  const { data } = await api.get<{ catalog: IEntityCatalogItem[] }>(BASE_CATALOG, {
    params: { entityType },
  });
  return data.catalog ?? [];
};

export const getFlowGraph = async (id: number) => {
  const { data } = await api.get<{ graph: IFlowGraph }>(`${BASE_FLOWS}/${id}/graph`);
  return data;
};

// newVersion preenchida quando quem salva diz que é uma nova versão do fluxo
export const saveFlowGraph = async (id: number, graph: IFlowGraphInput, newVersion?: string | null) => {
  const { data } = await api.put<{ graph: IFlowGraph; warnings: IFlowGraphIssue[] }>(
    `${BASE_FLOWS}/${id}/graph`,
    { graph, newVersion: newVersion || null },
    { skipErrorToast: true },
  );
  return data;
};

export const listGroups = async (): Promise<{ id: number; name: string }[]> => {
  const { data } = await api.get<{ groups: { id: number; name: string }[] }>("/global/groups", { params: { limit: 1000 } });
  return data.groups ?? [];
};
